(function () {
  if (window.__l51SiblingsInit) return;
  window.__l51SiblingsInit = true;

  const SECTION_ID = window.PRODUCT_CARD_SECTION_ID || 'api-product-grid-item';
  const SEL_CARD = '[data-grid-item], product-item';
  const SEL_GRID_SIBLING = '[data-sib-grid] .l51-sib-grid__item';

  function getStep(track) {
    if (!track) return 40;
    const item = track.querySelector('.l51-sib-grid__item');
    const gap = parseFloat(getComputedStyle(track).gap || 0);
    return item ? item.getBoundingClientRect().width + gap : 40;
  }

  function getHandleFromUrl(url) {
    try {
      const u = new URL(url, location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const i = parts.indexOf('products');
      return i >= 0 ? parts[i + 1] : null;
    } catch {
      return null;
    }
  }

  function updateGridState(root) {
    if (!root) return;

    const track = root.querySelector('[data-sib-grid-track]');
    const prev = root.querySelector('[data-sib-grid-prev]');
    const next = root.querySelector('[data-sib-grid-next]');
    if (!track || !prev || !next) return;

    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const left = Math.round(track.scrollLeft);

    if (maxScroll <= 2) {
      root.classList.add('is-static');
    } else {
      root.classList.remove('is-static');
    }

    prev.classList.toggle('is-disabled', left <= 2);
    next.classList.toggle('is-disabled', left >= maxScroll - 2);
  }

  function syncMoreButtonHeight(root) {
    if (!root) return;

    const moreBtn = root.querySelector('[data-sib-pdp-toggle]');
    const firstItem = root.querySelector('.l51-sib-pdp__item');
    if (!moreBtn || !firstItem) return;

    const h = firstItem.offsetHeight;
    if (h > 0) {
      moreBtn.style.height = h + 'px';
    }
  }

  function setPdpToggleState(root, expanded, syncItems = true) {
    if (!root) return;
  
    const btn = root.querySelector('[data-sib-pdp-toggle]');
    if (!btn) return;
  
    const countNode = btn.querySelector('.l51-sib-pdp__more-count');
    const textNode = btn.querySelector('.l51-sib-pdp__more-text');
    const moreCount = btn.getAttribute('data-more-count') || '';
  
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    btn.classList.toggle('is-less-mode', expanded);
  
    if (countNode) {
      countNode.textContent = expanded ? `-${moreCount}` : `+${moreCount}`;
    }
  
    if (textNode) {
      textNode.textContent = expanded ? 'Ver menos' : 'Mostrar';
    }
  
    if (syncItems) {
      root.querySelectorAll('.is-extra[data-sib-pdp-item]').forEach(function (item) {
        item.hidden = !expanded;
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');
      });
    }
  }

  function animatePdpToggle(root, expand) {
    if (!root) return;
  
    const grid = root.querySelector('.l51-sib-pdp__grid');
    if (!grid) {
      setPdpToggleState(root, expand);
      syncMoreButtonHeight(root);
      return;
    }
  
    if (grid.dataset.animating === 'true') return;
    grid.dataset.animating = 'true';
  
    const extraItems = Array.from(root.querySelectorAll('.is-extra[data-sib-pdp-item]'));
    const duration = 320;
  
    function cleanup() {
      grid.style.removeProperty('height');
      grid.style.removeProperty('overflow');
      grid.style.removeProperty('transition');
      grid.dataset.animating = 'false';
  
      extraItems.forEach(function (item) {
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');
        if (!expand) item.hidden = true;
      });
  
      setPdpToggleState(root, expand, false);
      syncMoreButtonHeight(root);
    }
  
    if (expand) {
      const startHeight = grid.offsetHeight;
  
      extraItems.forEach(function (item) {
        item.hidden = false;
        item.style.opacity = '0';
        item.style.transform = 'scale(.96)';
      });
  
      setPdpToggleState(root, true, false);
      syncMoreButtonHeight(root);
  
      const endHeight = grid.scrollHeight;
  
      grid.style.height = startHeight + 'px';
      grid.style.overflow = 'hidden';
      grid.style.transition = 'height 320ms cubic-bezier(.22,.61,.36,1)';
      grid.getBoundingClientRect();
  
      requestAnimationFrame(function () {
        grid.style.height = endHeight + 'px';
  
        extraItems.forEach(function (item) {
          item.style.opacity = '1';
          item.style.transform = 'scale(1)';
        });
      });
  
      const onEnd = function (e) {
        if (e.target !== grid || e.propertyName !== 'height') return;
        grid.removeEventListener('transitionend', onEnd);
        cleanup();
      };
  
      grid.addEventListener('transitionend', onEnd);
  
      setTimeout(function () {
        if (grid.dataset.animating === 'true') cleanup();
      }, duration + 120);
  
      return;
    }
  
    // CLOSE
    const startHeight = grid.offsetHeight;
  
    setPdpToggleState(root, false, false);
    syncMoreButtonHeight(root);
  
    // Medimos altura colapsada sin perder la visual actual
    extraItems.forEach(function (item) {
      item.hidden = true;
    });
    const endHeight = grid.scrollHeight;
    extraItems.forEach(function (item) {
      item.hidden = false;
    });
  
    grid.style.height = startHeight + 'px';
    grid.style.overflow = 'hidden';
    grid.style.transition = 'height 320ms cubic-bezier(.22,.61,.36,1)';
    grid.getBoundingClientRect();
  
    requestAnimationFrame(function () {
      extraItems.forEach(function (item) {
        item.classList.add('is-collapsing');
      });
  
      // dejamos un frame para que el fade empiece antes del colapso
      requestAnimationFrame(function () {
        grid.style.height = endHeight + 'px';
      });
    });
  
    const onEnd = function (e) {
      if (e.target !== grid || e.propertyName !== 'height') return;
      grid.removeEventListener('transitionend', onEnd);
      cleanup();
    };
  
    grid.addEventListener('transitionend', onEnd);
  
    setTimeout(function () {
      if (grid.dataset.animating === 'true') cleanup();
    }, duration + 120);
  }function animatePdpToggle(root, expand) {
    if (!root) return;
  
    const grid = root.querySelector('.l51-sib-pdp__grid');
    if (!grid) {
      setPdpToggleState(root, expand);
      syncMoreButtonHeight(root);
      return;
    }
  
    if (grid.dataset.animating === 'true') return;
    grid.dataset.animating = 'true';
  
    const extraItems = Array.from(root.querySelectorAll('.is-extra[data-sib-pdp-item]'));
    const duration = 320;
  
    function cleanup() {
      grid.style.removeProperty('height');
      grid.style.removeProperty('overflow');
      grid.style.removeProperty('transition');
      grid.dataset.animating = 'false';
  
      extraItems.forEach(function (item) {
        item.classList.remove('is-collapsing');
        item.style.removeProperty('opacity');
        item.style.removeProperty('transform');
        if (!expand) item.hidden = true;
      });
  
      setPdpToggleState(root, expand, false);
      syncMoreButtonHeight(root);
    }
  
    if (expand) {
      const startHeight = grid.offsetHeight;
  
      extraItems.forEach(function (item) {
        item.hidden = false;
        item.style.opacity = '0';
        item.style.transform = 'scale(.96)';
      });
  
      setPdpToggleState(root, true, false);
      syncMoreButtonHeight(root);
  
      const endHeight = grid.scrollHeight;
  
      grid.style.height = startHeight + 'px';
      grid.style.overflow = 'hidden';
      grid.style.transition = 'height 320ms cubic-bezier(.22,.61,.36,1)';
      grid.getBoundingClientRect();
  
      requestAnimationFrame(function () {
        grid.style.height = endHeight + 'px';
  
        extraItems.forEach(function (item) {
          item.style.opacity = '1';
          item.style.transform = 'scale(1)';
        });
      });
  
      const onEnd = function (e) {
        if (e.target !== grid || e.propertyName !== 'height') return;
        grid.removeEventListener('transitionend', onEnd);
        cleanup();
      };
  
      grid.addEventListener('transitionend', onEnd);
  
      setTimeout(function () {
        if (grid.dataset.animating === 'true') cleanup();
      }, duration + 120);
  
      return;
    }
  
    // CLOSE
    const startHeight = grid.offsetHeight;
  
    setPdpToggleState(root, false, false);
    syncMoreButtonHeight(root);
  
    // Medimos altura colapsada sin perder la visual actual
    extraItems.forEach(function (item) {
      item.hidden = true;
    });
    const endHeight = grid.scrollHeight;
    extraItems.forEach(function (item) {
      item.hidden = false;
    });
  
    grid.style.height = startHeight + 'px';
    grid.style.overflow = 'hidden';
    grid.style.transition = 'height 320ms cubic-bezier(.22,.61,.36,1)';
    grid.getBoundingClientRect();
  
    requestAnimationFrame(function () {
      extraItems.forEach(function (item) {
        item.classList.add('is-collapsing');
      });
  
      // dejamos un frame para que el fade empiece antes del colapso
      requestAnimationFrame(function () {
        grid.style.height = endHeight + 'px';
      });
    });
  
    const onEnd = function (e) {
      if (e.target !== grid || e.propertyName !== 'height') return;
      grid.removeEventListener('transitionend', onEnd);
      cleanup();
    };
  
    grid.addEventListener('transitionend', onEnd);
  
    setTimeout(function () {
      if (grid.dataset.animating === 'true') cleanup();
    }, duration + 120);
  }

  function initGrid(root) {
    if (!root || root.dataset.sibReady === 'true') return;
    root.dataset.sibReady = 'true';

    const track = root.querySelector('[data-sib-grid-track]');
    if (!track) return;

    track.addEventListener(
      'scroll',
      function () {
        updateGridState(root);
      },
      { passive: true }
    );

    requestAnimationFrame(function () {
      updateGridState(root);
    });

    setTimeout(function () {
      updateGridState(root);
    }, 80);

    setTimeout(function () {
      updateGridState(root);
    }, 220);
  }

  function initPdp(root) {
    if (!root || root.dataset.sibPdpReady === 'true') return;
    root.dataset.sibPdpReady = 'true';

    setPdpToggleState(root, false);

    requestAnimationFrame(function () {
      syncMoreButtonHeight(root);
    });

    setTimeout(function () {
      syncMoreButtonHeight(root);
    }, 80);
  }

  function initAll(scope) {
    const ctx = scope || document;
    ctx.querySelectorAll('[data-sib-grid]').forEach(initGrid);
    ctx.querySelectorAll('[data-sib-pdp]').forEach(initPdp);
  }

  async function swapCardFromSibling(linkEl) {
    const card = linkEl.closest(SEL_CARD);
    if (!card) return;

    const siblingUrl = linkEl.getAttribute('href') || '';
    const handle = getHandleFromUrl(siblingUrl);
    if (!handle) return;

    let requestUrl;
    try {
      const u = new URL(siblingUrl, location.origin);
      u.searchParams.set('section_id', SECTION_ID);
      requestUrl = u.toString();
    } catch {
      return;
    }

    card.classList.add('is-loading');

    try {
      const res = await fetch(requestUrl, { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newItem = doc.querySelector('[data-grid-item], product-item');
      if (!newItem) return;

      const doSwap = function () {
        if (window.theme?.htmlUpdate?.viewTransition) {
          window.theme.htmlUpdate.viewTransition(card, newItem, []);
        } else {
          card.replaceWith(newItem);
        }

        initAll(newItem);

        requestAnimationFrame(function () {
          newItem.querySelectorAll('[data-sib-grid]').forEach(updateGridState);
          newItem.querySelectorAll('[data-sib-pdp]').forEach(syncMoreButtonHeight);
        });
      };

      requestAnimationFrame(doSwap);
    } catch (err) {
      console.warn('Swap de sibling falló', err);
    } finally {
      card.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('[data-sib-pdp-toggle]');
    const prevBtn = e.target.closest('[data-sib-grid-prev]');
    const nextBtn = e.target.closest('[data-sib-grid-next]');
    const siblingLink = e.target.closest(SEL_GRID_SIBLING);

    if (toggleBtn) {
      const root = toggleBtn.closest('[data-sib-pdp]');
      if (!root) return;

      const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      animatePdpToggle(root, !expanded);
      return;
    }

    if (prevBtn) {
      const root = prevBtn.closest('[data-sib-grid]');
      const track = root && root.querySelector('[data-sib-grid-track]');
      if (!track) return;

      track.scrollBy({ left: -(getStep(track) * 3), behavior: 'smooth' });
      return;
    }

    if (nextBtn) {
      const root = nextBtn.closest('[data-sib-grid]');
      const track = root && root.querySelector('[data-sib-grid-track]');
      if (!track) return;

      track.scrollBy({ left: getStep(track) * 3, behavior: 'smooth' });
      return;
    }

    if (siblingLink) {
      const inGrid = siblingLink.closest('[data-sib-grid]');
      if (!inGrid) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      swapCardFromSibling(siblingLink);
    }
  }, true);

  let resizeRaf = null;
  window.addEventListener('resize', function () {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(function () {
      document.querySelectorAll('[data-sib-grid]').forEach(updateGridState);
      document.querySelectorAll('[data-sib-pdp]').forEach(function (root) {
        syncMoreButtonHeight(root);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  const observer = new MutationObserver(function (mutations) {
    let shouldReinit = false;

    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches?.('[data-sib-grid], [data-sib-pdp], [data-grid-item], product-item') ||
          node.querySelector?.('[data-sib-grid], [data-sib-pdp], [data-grid-item], product-item')
        ) {
          shouldReinit = true;
        }
      });
    });

    if (shouldReinit) {
      initAll(document);

      requestAnimationFrame(function () {
        document.querySelectorAll('[data-sib-grid]').forEach(updateGridState);
        document.querySelectorAll('[data-sib-pdp]').forEach(function (root) {
          syncMoreButtonHeight(root);
        });
      });
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();